import { connect } from 'react-redux'
import { notifyActions, vpnActions } from '../store/actions';
import pageVpn from './pages/peer';

const mapStateToProps = state => {
    return {
        ...state,
        vpn: state.vpn,
        role: state.role,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setNumberVpnPeer: (data) => {
            dispatch(vpnActions.setNumberVpnPeer(data))
        },
        setMachineIdForDetail: (data) => {
            dispatch(vpnActions.setMachineIdForDetail(data))
        },
        successNotify: (message) => {
            dispatch(notifyActions.successAction(message))
        },
        warningNotify: (message) => {
            dispatch(notifyActions.warningAction(message))
        },
        errorNotify: (message) => {
            dispatch(notifyActions.errorAction(message))
        },
        infoNotify: (message) => {
            dispatch(notifyActions.infoAction(message))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageVpn);